// React imports.
import React, { Component } from "react";

// App imports.
import * as utility from "../utility";

const ReadingIndexValues = ({ history }) => (
  <React.Fragment>
    <p style={{ "textAlign": "center" }}><strong><span style={{ "textDecoration": "underline" }}>Interpreting Index Values</span></strong></p>

    {history.IndexCode === utility.IndexCodeEnum.TargetingIndex
      &&
      <React.Fragment>
        <ul>
          <li><strong>Index Value &gt; 100</strong>: On average, high burden households received <em>larger</em> benefits than the average LIHEAP household.<br /><br /> </li>
          <li><strong>Index Value = 100</strong>: On average, high burden households received <em>the same</em> level of benefit as the average LIHEAP household.<br /><br />
          </li>
          <li><strong>Index Value &lt; 100</strong>: On average, high burden households received <em>smaller</em> benefits than the average LIHEAP household.<br /><br /></li>
        </ul>
      </React.Fragment>
    }
    {history.IndexCode === utility.IndexCodeEnum.BurdenReductionIndex
      &&
      <React.Fragment>
        <ul >
          <li><strong>Index Value &gt; 100</strong>: On average, LIHEAP paid a <em>larger share</em> of the bill for high burden households than for the average LIHEAP household.<br /><br />
          </li>
          <li><strong>Index Value = 100</strong>: On average, LIHEAP paid the same portion of the bill for high burden households as it did for the average LIHEAP household.<br /><br />
          </li>
          <li><strong>Index Value &lt; 100</strong>: On average, LIHEAP paid a <em>smaller share </em>of the bill for your high burden households compared to the portion of the bill paid for the average LIHEAP household.<br /><br /></li>
        </ul>
      </React.Fragment>
    }
  </React.Fragment>
);

export default ReadingIndexValues;
